import { render, staticRenderFns } from "./_contactListUuid.vue?vue&type=template&id=63c3f67c"
import script from "./_contactListUuid.vue?vue&type=script&lang=js"
export * from "./_contactListUuid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports